/* eslint-disable */
// @ts-nocheck
import * as R from 'ramda';
import { reducerWrapper } from '../support/utils';
import { PAYMENT_METHODS, SET_PAYMENT_METHOD_AS_DEFAULT, PAYMENT_METHODS_DELETE } from '../actions/SubscriptionActions';
import NotificationActions from '../actions/NotificationActions';
import type { PaymentMethodReducer } from '../types/paymentMethodTypes';
export const INIT_STATE: PaymentMethodReducer = {
  loading: false,
  error: null,
  data: [],
};

function Handler(state: PaymentMethodReducer, action) {
  const { data } = action;

  switch (action.type) {
    case PAYMENT_METHODS.response:
      return Object.assign({}, state, {
        loading: false,
        data,
      });

    case SET_PAYMENT_METHOD_AS_DEFAULT.response:
      NotificationActions.showNotification(`You successfully updated your payment method`, 'success');
      return Object.assign({}, state, {
        loading: false,
        data: state.data.map((cc) => {
          if (cc.id !== data.id) {
            return { ...cc, defaultPaymentMethod: false };
          }
          return { ...cc, defaultPaymentMethod: true };
        }),
      });

    case PAYMENT_METHODS_DELETE.response:
      return Object.assign({}, state, {
        loading: false,
        data: R.reject(R.propEq('id', data.id), state.data),
      });

    default:
      return state;
  }
}

const Payments = reducerWrapper(INIT_STATE, Handler, {
  request: [PAYMENT_METHODS, SET_PAYMENT_METHOD_AS_DEFAULT, PAYMENT_METHODS_DELETE],
  error: [PAYMENT_METHODS, SET_PAYMENT_METHOD_AS_DEFAULT, PAYMENT_METHODS_DELETE],
  resetOn: ['APP_CHANGE'],
});
export default Payments;
